export const SITE_URL = 'https://superbuyspread.lol';